export default function createFeatureGuard(store, feature) {
  // eslint-disable-next-line consistent-return
  return (to, from, next) => {
    if (store?.getters['generalStore/hasFeature']?.(feature)) {
      return next();
    }
    return next(false);
  };
}
